<template>
  <div class="base-display">
    <img :src="require('@/assets/daping/base.svg')" class="base-img" />
    <div :class="['base-data', baseDataList.length == 3 ? 'base-data-three' : '', isPadding == '1' ? 'isPaddingOne' : isPadding == '2' ? 'isPaddingTwo': '']">
      <div v-for="(item, index) in baseDataList" :key="index" class="list">
        <img :src="item.img" class="base-data-img" />
        <div class="name-num">
          <div class="name">{{ item.name }}</div>
          <div class="num">{{ item.num }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "index",
  components: {},
  props: {
    baseDataList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    isPadding: {
      type: String,
      default: ''
    }
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
<style scoped lang="less">
.base-display {
  display: flex;
  align-items: center;
  position: relative;
  margin: 20px 0 0 10px;
  .base-img {
    width: 707px;
    position: absolute;
    top: 40px;
  }
  .base-data {
    display: flex;
    width: 707px;
    padding: 0 30px;
    .list {
      display: flex;
      width: 25%;
      .name-num {
        margin: 0 0 0 12px;
      }
      .name {
        font-family: MiSans, MiSans;
        font-weight: 400;
        font-size: 16px;
        color: #adc2d3;
        line-height: 26px;
      }
      .num {
        font-family: MiSans, MiSans;
        font-weight: 500;
        font-size: 22px;
        color: #e4f2ff;
        line-height: 29px;
      }
    }
    .base-data-img {
      width: 59px;
      height: 60px;
    }
  }
  .base-data-three {
    padding: 0 35px 0 92px;
    .list {
      width: 33.3%;
    }
  }
  .isPaddingOne {
    .list {
      width: 28.3%;
    }
    .list:last-child {
      width: 20%;
    }
  }
  .isPaddingTwo {
    padding: 0 0 0 20px;
    .list {
      width: 28.3%;
    }
    .list:last-child {
      width: 20%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/patrolScreen/components/base-display.vue